import { gql } from "@apollo/client";
//auth
export const AUTH = gql`
  query {
    auth {
      id
      name
      email
      phone
      profile_image
    }
  }
`;
export const PAYMENT_TYPES = gql`
  query {
    paymentTypesNonPaginated {
      id
      name
      logo
      status
    }
  }
`;

//category queries

export const GET_CATEGORIES = gql`
  query GET_CATEGORIES(
    $first: Int!
    $search: String
    $page: Int
    $ordered_by: [OrderByInput]
  ) {
    categories(
      first: $first
      search: $search
      page: $page
      parentOnly: true
      orderBy: $ordered_by
    ) {
      data {
        id
        name
        productCount
        deleted_at
        productSkusCount
        isParent
        imageUrl
        image {
          id
          original_url
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_SALESES = gql`
  query (
    $search: String
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    getSales(
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        user {
          id
          name
          email
          phone
          profile_image
          status
        }
        city
        region {
          id
          name
        }
        address
        sub_city
        woreda
        suppliersRegistered
        retailersRegistered
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_STAFFS = gql`
  query ($search: String, $first: Int!, $page: Int) {
    staffs(search: $search, first: $first, page: $page) {
      data {
        id
        name
        phone
        status
        email
        supplierBusinesses {
          business_name
          id
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_RETAILERS_LOAN_REPORT = gql`
  query GetRetailersLoanReport(
    $search: String
    $user_id: ID
    $startDate: String
    $endDate: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    getRetailersLoanReport(
      search: $search
      user_id: $user_id
      startDate: $startDate
      endDate: $endDate
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        retailer {
          id
          name
          contact_phone
        }
        total_loans_amount
        total_paid_amount
        loan_requests {
          id
          amount
          interest
          total_payable
          remaining_balance
          paid_amount
          status
          loan_request_status
          due_date
          microfinance {
            id
            name
          }
          payments {
            id
            amount
            payment_method
            payment_date
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const INVENTORY_REPORT = gql`
  query GetInventoryReport(
    $warehouse_ids: [ID!]
    $search: String
    $category_id: ID
    $supplier_id: ID
    $period: Period
    $start_date: Date
    $end_date: Date
    $first: Int
    $page: Int
  ) {
    getProductsWithStockLevels(
      warehouse_ids: $warehouse_ids
      search: $search
      category_id: $category_id
      supplier_id: $supplier_id
      period: $period
      start_date: $start_date
      end_date: $end_date
      first: $first
      page: $page
    ) {
      data {
        id
        name
        unit_price
        total_stock_level
        sold_quantity
        sold_items_total_price
        remaining_items_total_price
        price_difference
        category {
          name
        }
        stock_by_warehouse {
          warehouse_name
          quantity
        }
      }
      total_sold_amount
      total_remaining_balance
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const LOAN_REQUESTS = gql`
  query LoanRequests(
    $search: String
    $status: LoanRequestStatus
    $min_amount: Float
    $max_amount: Float
    $retailer_id: ID
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput!]
  ) {
    loanRequests(
      search: $search
      status: $status
      min_amount: $min_amount
      max_amount: $max_amount
      user_id: $retailer_id
      first: $first
      page: $page
      ordered_by: $ordered_by
    ) {
      data {
        id
        user {
          id
          name
          phone
          email
        }
        amount
        status
        due_date
        microfinance {
          id
          name
        }
        interest_rate
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const LOAN_PROVIDERS = gql`
  query LoanProviders(
    $search: String
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput!]
  ) {
    loanProviders(
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        user_id
        name
        code
        description
        contact_email
        #user_phone
        contact_phone
        status
        website
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const ADMIN_LOAN_CATEGORIES = gql`
  query loanCategories(
    $search: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    loanCategories(
      search: $search
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        name
        description
        icon
        status
        sort_order
        created_at
        provider {
          id
          name
          code
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastPage
        total
      }
    }
  }
`;

export const ADMIN_LOAN_PRODUCTS = gql`
  query loanProducts(
    $search: String
    $provider_id: ID
    $category_id: ID
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    loanProducts(
      search: $search
      provider_id: $provider_id
      category_id: $category_id
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        provider {
          id
          name
          code
        }

        category {
          id
          name
        }
        name
        description
        interest_type
        interest_rate
        repayment_frequency
        min_amount
        max_amount
        min_term
        max_term
        processing_fee_type
        processing_fee
        penalty_rate
        grace_period_days
        credit_score
        risk_tier
        recommended_loan_limit
        credit_score_confidence
        credit_score_reasons
        status
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastPage
        total
      }
    }
  }
`;

// Loan Payments Query
export const LOAN_PAYMENTS = gql`
  query LoanPayments(
    $loan_account_id: ID
    $user_id: ID
    $payment_method: String
    $product_id: ID
    $search: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    loanPayments(
      loan_account_id: $loan_account_id
      user_id: $user_id
      payment_method: $payment_method
      product_id: $product_id
      search: $search
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        trx
        loan_account_id
        installment_id
        user {
          id
          name
          phone
          email
        }
        user_id
        amount
        penalty_paid
        interest_paid
        principal_paid
        payment_method
        remark
        recorded_by
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const LOAN_SCHEDULE = gql`
  query LoanSchedule(
    $loan_account_id: ID!
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    loanSchedule(
      loan_account_id: $loan_account_id
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        loan_account_id
        installment_no
        due_date
        principal_due
        interest_due
        total_due
        penalty_due
        amount_paid
        status
        paid_at
        last_penalty_accrued_at
        reminder_sent_at
        created_at
        updated_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_TRANSACTIONS = gql`
  query GetCheckoutTransactions(
    $payment_method: String
    $start_date: String
    $end_date: String
    $period: String
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput]
  ) {
    getCheckoutTransactions(
      payment_method: $payment_method
      start_date: $start_date
      end_date: $end_date
      period: $period
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        payment_method
        amount
        user {
          id
          name
          email
          phone
        }
        commission
        txn_ref
        status
        created_at
        retailer_name
        warehouse_name
        order_code
        product_items {
          id
          product_name
          quantity
          price
          image
        }
        assigned_driver
        date_time
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const WALLET_TRANSACTIONS = gql`
  query GetWalletTransactions(
    $payment_method: String
    $user_type: String
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    getWalletTransactions(
      payment_method: $payment_method
      user_type: $user_type
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        name
        email
        phone
        total_amount
        total_commission
        transaction_count
        transactions {
          id
          payment_method
          amount
          commission
          txn_ref
          status
          created_at
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const DRIVER_TRANSACTIONS = gql`
  query GetDriversTransactionsReport(
    $period: String
    $startDate: String
    $endDate: String
    $driver_id: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    getDriversTransactionsReport(
      period: $period
      startDate: $startDate
      endDate: $endDate
      driver_id: $driver_id
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      all_drivers_total_amount
      all_drivers_transaction_count
      data {
        driver_id
        driver_name
        driver_phone
        vehicle_type
        vehicle_model
        plate_number
        total_amount
        transaction_count
        transactions {
          name
          phone
          amount
          vehicle_model
          plate_number
          vehicle_type
          date
          retailer {
            id
            name
            contact_phone
          }
          warehouse {
            id
            name
          }
          order_code
        }
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const RETAILER_TRANSACTIONS = gql`
  query GetRetailerTransactionReport(
    $search: String
    $retailer_id: ID
    $type: String
    $startDate: String
    $endDate: String
    $first: Int!
    $page: Int
  ) {
    getRetailerTransactionReport(
      search: $search
      retailer_id: $retailer_id
      type: $type
      startDate: $startDate
      endDate: $endDate
      first: $first
      page: $page
    ) {
      all_retailers_total_amount
      data {
        retailer_id
        total_amount
        transaction_count
        retailer {
          id
          user {
            name
            phone
            email
          }
        }
        transactions {
          id
          amount
          type
          status
          description
          payment_method
          created_at
          retailer_name
          user_name
          user_phone
          warehouse_name
          supplier_name
          supplier_phone
          supplier_business_name
          date
        }
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const SUPPLIER_TRANSACTIONS_REPORT = gql`
  query (
    $period: String
    $startDate: String
    $endDate: String
    $supplier_id: ID
    $type: String
    $is_sme: Boolean
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    getSupplierTransactionsReport(
      period: $period
      startDate: $startDate
      endDate: $endDate
      is_sme: $is_sme
      supplier_id: $supplier_id
      type: $type
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        supplier_name
        supplier_phone
        total_amount
        transaction_count
        businesses {
          id
          business_name
          business_phone
          total_amount
          transaction_count
          transactions {
            id
            amount
            type
            status
            description
            payment_method
            created_at
            date
          }
        }
      }
      total_suppliers_amount
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const SME_SUPPLIER_TRANSACTIONS_REPORT = gql`
  query GetSmeSupplierTransactionsReport(
    $period: String
    $startDate: String
    $endDate: String
    $supplier_id: ID
    $type: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    getSmeSupplierTransactionsReport(
      period: $period
      startDate: $startDate
      endDate: $endDate
      supplier_id: $supplier_id
      type: $type
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      total_suppliers_amount
      data {
        id
        supplier_name
        supplier_phone
        total_amount
        credit_total
        debit_total
        transaction_count
        businesses {
          id
          business_name
          business_phone
          total_amount
          credit_total
          debit_total
          transaction_count
          transactions {
            id
            amount
            type
            status
            description
            payment_method
            created_at
            date
          }
        }
      }
      paginatorInfo {
        currentPage
        lastPage
        total
        count
        perPage
      }
    }
  }
`;

export const COMMISSION_SUMMARY_REPORT = gql`
  query (
    $period: String
    $startDate: String
    $endDate: String
    $supplier_id: ID
    $driver_id: ID
  ) {
    getCommissionSummaryReport(
      period: $period
      startDate: $startDate
      endDate: $endDate
      supplier_id: $supplier_id
      driver_id: $driver_id
    ) {
      total_supplier_commission
      total_driver_commission
      total_commission
      total_sme_commission
    }
  }
`;
export const DRIVER_COMMISTIONS = gql`
  query GetDriverCommissionTransactions(
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput]
    $start_date: String
    $end_date: String
    $period: String
  ) {
    getDriverCommissionTransactions(
      first: $first
      page: $page
      orderBy: $ordered_by
      start_date: $start_date
      end_date: $end_date
      period: $period
    ) {
      data {
        driver_id
        driver_name
        driver_phone
        total_amount
        total_commission
        transaction_count
        transactions {
          id
          amount
          commission_cost
          drop_off_status
          date_time
          driver_name
          retailer_name
          warehouse
          order_code
        }
        created_at
      }

      all_drivers_total_commission
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const SUPPLIER_TRANSACTIONS = gql`
  query (
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput]!
    $start_date: String
    $end_date: String
    $period: String
  ) {
    getSupplierCommissionTransactions(
      first: $first
      page: $page
      orderBy: $ordered_by
      start_date: $start_date
      end_date: $end_date
      period: $period
    ) {
      data {
        supplier_id
        total_commission
        transaction_count
        supplier {
          id
          user {
            name
            phone
            email
          }
        }
        businesses {
          business_id
          business_name
          business_type
          business_phone_number
          business_email
          total_commission
          transaction_count
          created_at
        }
        created_at
      }
      all_suppliers_total_commission
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_Attributes = gql`
  query GET_Attributes(
    $search: String
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    attributes(
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        name
        category {
          id
          name
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_SALESES_WAREHOUSE = gql`
  query ($id: String!) {
    getAssignedWarehouses(id: $id) {
      id
      warehouse {
        id
        name
        status
        specific_area
        region {
          id
          name
        }
        supplier {
          id
          business_name
        }
      }
    }
  }
`;
export const GET_Product_CATEGORIES = gql`
  query GET_PRODUCT_CATEGORIES(
    $supplier_id: String
    $search: String
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    supplierProductCategories(
      supplier_id: $supplier_id
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        category {
          name
        }
        supplier {
          business_name
          business_type
          business_phone_number
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_Values = gql`
  query GET_PRODUCT_values($attribute_id: ID!) {
    attributeValues(attribute_id: $attribute_id) {
      data {
        id
        value
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_CATEGORIES_ALL = gql`
  query GET_CATEGORIES($first: Int!, $page: Int) {
    categories(first: $first, page: $page) {
      data {
        id
        name
        name_translations {
          en
          am
        }
        isParent
        image
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const FILTER_PRODUCT_BY_CATEGORY = gql`
  query FilterProductByCategory(
    $category_id: String!
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    filterProducts(
      category_id: $category_id
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        name
        category {
          id
          name
        }
        productSkusCount
        imageUrl
        description
        short_description
        images {
          id
          original_url
        }
        attributes {
          id
          name
          values {
            id
            value
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_CATEGORY = gql`
  query ($id: ID!) {
    category(id: $id) {
      id
      name
      imageUrl
      image {
        id
        original_url
      }
      children_count
      children {
        id
        name
        imageUrl
        products {
          id
          name
          description
          imageUrl
          images {
            id
            original_url
          }
        }
      }
    }
  }
`;

// warehouse queries
export const GET_WARE_HOUSES = gql`
  query GET_WARE_HOUSES($first: Int!, $search: String, $page: Int!) {
    warehouses(first: $first, search: $search, page: $page) {
      data {
        id
        name
        status
        specific_area
        region {
          id
          name
        }
        stocks {
          id
          quantity
        }
        _geo {
          lat
          lng
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_MY_WARE_HOUSES = gql`
  query GET_MY_WARE_HOUSES($first: Int!, $search: String, $page: Int!) {
    myWarehouses(first: $first, search: $search, page: $page) {
      data {
        id
        name
        status
        specific_area
        region {
          id
          name
        }
        supplier {
          id
          business_name
          categories {
            category {
              id
              name
              children {
                id
                name
              }
            }
          }
        }
        stocks {
          id
          quantity
        }
        _geo {
          lat
          lng
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_WARE_HOUSE = gql`
  query GET_WARE_HOUSE($id: ID!) {
    warehouse(id: $id) {
      id
      name
      specific_area
      region {
        id
        name
      }
      _geo {
        lat
        lng
      }
    }
  }
`;

// distributor queries

export const GET_DISTRIBUTOR = gql`
  query ($id: ID) {
    distributor(id: $id) {
      id
      name
      contact_email
      contact_name
      contact_phone
      city
      address
      _geo {
        lat
        lng
      }
    }
  }
`;
export const GET_DISTRIBUTORS = gql`
  query ($first: Int!, $page: Int) {
    distributors(first: $first, page: $page) {
      data {
        id
        name
        contact_phone
        _geo {
          lat
          lng
        }
        city
        contact_name
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const REPORT = gql`
  query (
    $period: String
    $startDate: String
    $endDate: String
    $warehouse: String
    $supplier_business: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    getSupplierSalesReport(
      period: $period
      startDate: $startDate
      endDate: $endDate
      warehouse: $warehouse
      supplier_business: $supplier_business
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        orderCode
        price
        numberOfItems
        date
        supplier_business
        warehouse
      }
      total_price
      paginatorInfo {
        currentPage
        lastPage
        total
        count
        perPage
      }
    }
  }
`;
export const Manager_REPORT = gql`
  query (
    $period: String
    $startDate: String
    $endDate: String
    $product: String
    $warehouse: String
    $retailer: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    getWarehouseManagerSalesReport(
      period: $period
      startDate: $startDate
      endDate: $endDate
      product: $product
      warehouse: $warehouse
      retailer: $retailer
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        productName
        quantity
        total_price
        date
        warehouse
        warehouseRegion
        retailer
        retailerRegion
      }
      total_price
      paginatorInfo {
        currentPage
        lastPage
        total
        count
        perPage
      }
    }
  }
`;
export const GET_REGIONS = gql`
  query ($first: Int!, $search: String, $page: Int) {
    regions(first: $first, search: $search, page: $page) {
      data {
        id
        name
        warehouses {
          id
          status
          name
          specific_area
        }
        driversCount
        retailersCount
        warehousesCount
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_REGION = gql`
  query get_region($id: ID) {
    region(id: $id) {
      id
      name
      name_translations {
        en
        am
      }
      specific_areas
    }
  }
`;

export const GET_ACTIVITY_LOGS = gql`
  query (
    $causer_id: Int
    $log_name: String
    $from_date: String
    $to_date: String
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    getActivityLogs(
      causer_id: $causer_id
      log_name: $log_name
      from_date: $from_date
      to_date: $to_date
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        log_name
        event
        properties
        causer {
          ... on User {
            id
            name
          }
        }
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_PRODUCT_RETURN = gql`
  query (
    $search: String
    $first: Int
    $status: String
    $page: Int
    $ordered_by: [OrderByInput]
  ) {
    productReturns(
      search: $search
      status: $status
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        quantity
        reason
        status
        orderItem {
          price
          product_sku {
            product {
              id
              name
            }
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
      total_price
    }
  }
`;

export const GET_MY_PRODUCT_RETURN = gql`
  query (
    $search: String
    $first: Int
    $status: String
    $page: Int
    $ordered_by: [OrderByInput]
  ) {
    getProductReturnsSupplierOrWarehouseManager(
      search: $search
      limit: $first
      status: $status
      page: $page
      orderBy: $ordered_by
    ) {
      total_price
      data {
        id
        quantity
        reason
        status
        orderItem {
          price
          product_sku {
            product {
              id
              name
            }
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_PRODUCTS = gql`
  query GET_PRODUCTS(
    $first: Int!
    $category_id: String
    $user_id: Int
    $search: String
    $page: Int
  ) {
    products(
      search: $search
      category_id: $category_id
      user_id: $user_id
      first: $first
      page: $page
    ) {
      data {
        id
        name
        minimum_order_quantity
        product_type
        supplier {
          user {
            name
            phone
          }
        }
        skus {
          id
          sku
          sell_price
          buy_price
          stockCount
          is_active
          variants {
            id
            value
            attribute {
              id
              name
            }
          }
        }
        description
        discount {
          discount_value
        }
        supplier {
          id
          business_name
        }
        category {
          id
          name
          children {
            name
            id
          }
        }
        productSkusCount
        short_description
        images {
          id
          original_url
          is_default
        }
        attributes {
          id
          name
          values {
            id
            value
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_MY_STOCKS = gql`
  query GET_MY_STOCKS(
    $search: String
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    myStocks(
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        name
        quantity
        product_type
        category {
          id
          name
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_MY_PRODUCTS = gql`
  query GET_MY_PRODUCTS(
    $first: Int!
    $supplier_business_id: String
    $category_id: String
    $search: String
    $page: Int
  ) {
    myProducts(
      search: $search
      first: $first
      supplier_business_id: $supplier_business_id
      category_id: $category_id
      page: $page
    ) {
      data {
        id
        name
        minimum_order_quantity
        product_type
        skus {
          id
          sku
          sell_price
          buy_price
          stockCount
          is_active
          variants {
            id
            value
            attribute {
              id
              name
            }
          }
        }
        description
        discount {
          discount_value
        }
        supplier {
          id
          business_name
        }
        category {
          id
          name
          children {
            name
            id
          }
        }
        productSkusCount
        short_description
        images {
          id
          original_url
          is_default
        }
        attributes {
          id
          name
          values {
            id
            value
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const NON_PAGINATED_CATEGORIES = gql`
  query {
    categoryNonPaginated {
      id
      name
      children {
        name
        id
      }
      attributes {
        id
        name
        values {
          id
          value
        }
      }
    }
  }
`;
export const NON_PAGINATED_DRIVERS = gql`
  query {
    driversNonPaginated {
      id
      user {
        id
        name
      }
    }
  }
`;
export const GET_PRODUCT = gql`
  query ($id: ID!) {
    product(id: $id) {
      id
      name
      minimum_order_quantity
      description
      short_description
      is_active
      category {
        id
        name
      }
      product_type
      imageUrl
      images {
        id
        original_url
        is_default
      }
      attributes {
        id
        name
        values {
          id
          value
        }
      }
      skus {
        id
        sku
        sell_price
        stockCount
        is_active
      }
      productSkusCount
      orderCount
    }
  }
`;
export const GET_TRANSACTION = gql`
  query ($id: ID!) {
    getTransactionById(id: $id) {
      id
      payment_method
      amount
      commission
      txn_ref
      status
      created_at
      orders {
        id
        order_code
        delivery_option
        total_price
        created_at_human
        status
        created_at
        retailer {
          id
          name
          region {
            name
          }
          city
          address
          contact_phone
          contact_email
        }
        state
        warehouse {
          name
        }
        driver {
          id
          user {
            name
          }
        }
        productSkuCount
        items {
          id
          quantity
          state
          product_sku {
            id
            sku
            sell_price
            product {
              name
              imageUrl
            }
          }
        }
      }
    }
  }
`;
// productsku queries
export const GET_PRODUCT_SKU = gql`
  query ($id: ID!) {
    productSku(id: $id) {
      id
      sku
      price
      is_active
      buy_price
    }
  }
`;
export const GET_PRODUCT_STOCKS = gql`
  query ($product_id: String!) {
    getStocksByProduct(product_id: $product_id) {
      id
      quantity
      minimum_stock_level
      warehouse {
        id
        name
      }
      created_at
      product_sku {
        id
        sku
        variants {
          id
          value
          attribute {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_PRODUCT_SKUS = gql`
  query ($product_id: String!) {
    productSkus(product_id: $product_id) {
      id
      sell_price
      buy_price
      variants {
        id
        value
        attribute {
          id
          name
        }
      }
    }
  }
`;
// Analytics query
export const GET_ANALYTICS = gql`
  query GetAnalytics {
    getAnalytics {
      orders
      ordersChange
      shipments
      shipmentsChange
      totalSales
      totalSalesChange
      totalActiveProducts
      totalActiveProductsChange
    }
  }
`;
//retailer
export const GET_RETAILER = gql`
  query ($id: ID) {
    retailer(id: $id) {
      id
      name
      contact_email
      contact_name
      contact_phone
      region {
        id
        name
      }
      _geo {
        lat
        lng
      }
      address
      city
      orders {
        id
        total_price
        warehouse {
          name
        }
        order_code
        status
      }
    }
  }
`;
export const NON_PAGE_RETAILERS = gql`
  query {
    retailersNonPaginated {
      id
      name
      user {
        name
        id
      }
    }
  }
`;

export const NOPAGE_RETAILERS = gql`
  query ($first: Int, $page: Int, $ordered_by: [OrderByInput]) {
    retailers(first: $first, page: $page, orderBy: $ordered_by) {
      data {
        id
        name
        address
        user {
          id
          name
        }
        _geo {
          lat
          lng
        }
        region {
          id
          name
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_RETAILERS = gql`
  query (
    $sales_id: String
    $region_id: String
    $period: String
    $startDate: String
    $endDate: String
    $first: Int
    $search: String
    $page: Int
    $ordered_by: [OrderByInput]
  ) {
    retailers(
      sales_id: $sales_id
      region_id: $region_id
      period: $period
      startDate: $startDate
      endDate: $endDate
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        name
        address
        contact_email
        user {
          id
          name
          phone
          email
          status
        }
        _geo {
          lat
          lng
        }
        registeredBy {
          id
          name
        }
        wallet {
          id
          balance
        }
        city
        region {
          id
          name
        }
        orderCount
        contact_phone
        contact_name
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_RETAILER_AGENTS = gql`
  query AgentSuppliers(
    $retailer_id: ID
    $supplier_id: ID
    $search: String
    $first: Int
    $page: Int
  ) {
    agentSuppliers(
      retailer_id: $retailer_id
      supplier_id: $supplier_id
      search: $search
      first: $first
      page: $page
    ) {
      data {
        id
        retailer {
          id
          name
          contact_email
          contact_phone
          city
          region {
            name
          }
        }
        supplier {
          id
        }
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_RETAILERS_WITH_SUPPLIERS = gql`
  query ($search: String, $first: Int, $page: Int) {
    retailersWithSuppliers(search: $search, first: $first, page: $page) {
      data {
        retailer_id
        name
        phone
        email
        supplier_count
      }
      paginatorInfo {
        total
        currentPage
        lastPage
        perPage
      }
    }
  }
`;

export const GET_SUPPLIERS_BY_RETAILER = gql`
  query ($retailer_id: ID!, $search: String, $first: Int, $page: Int) {
    suppliersByRetailerId(
      retailer_id: $retailer_id
      search: $search
      first: $first
      page: $page
    ) {
      data {
        supplier_id
        name
        phone
        email
        status
        is_sme
        added_at
      }
      paginatorInfo {
        total
        currentPage
        lastPage
        perPage
      }
    }
  }
`;

export const GET_SUPPLIERS = gql`
  query ($first: Int!, $search: String, $page: Int) {
    suppliers(first: $first, search: $search, page: $page) {
      data {
        id
        city
        user {
          name
          phone
          email
        }
        address
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_SUPPLIERS_Commission = gql`
  query ($first: Int!, $search: String, $page: Int, $is_sme: Boolean) {
    supplier_configurations(
      first: $first
      search: $search
      page: $page
      is_sme: $is_sme
    ) {
      data {
        id
        commission_rate
        payment_mode
        calculation_type
        subscription_fee_amount
        fee_interval
        fee_on_date
        supplier {
          id
          user {
            name
            phone
            email
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_SUPPLIERS_Business = gql`
  query (
    $search: String
    $supplier_id: String
    $status: String
    $first: Int!
    $is_sme: Boolean
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    suppliersBusinesses(
      search: $search
      supplier_id: $supplier_id
      status: $status
      first: $first
      is_sme: $is_sme
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        supplier_code
        business_kebele
        business_zone
        business_woreda
        owner_firstname
        owner_id_type
        owner_middlename
        owner_phone_number
        business_name
        business_email
        business_website
        business_phone_number
        owner_lastname
        business_type
        business_region {
          id
          name
        }

        business_geo_location {
          lat
          lng
        }
        number_of_warehouses
        tin
        status
        owner_id_url
        trade_license_document_url
        tin_certification_document_url
        business_registration_number
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_MY_SUPPLIERS_Business = gql`
  query (
    $search: String
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    myBusinesses(
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        supplier_code
        business_kebele
        business_zone
        business_woreda
        total_balance
        owner_firstname
        owner_middlename
        owner_phone_number
        business_name
        business_email
        business_website
        business_phone_number
        owner_lastname
        business_type
        business_region {
          id
          name
        }

        business_geo_location {
          lat
          lng
        }
        number_of_warehouses
        tin
        status
        owner_id_url
        trade_license_document_url
        tin_certification_document_url
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_SUPPLIERS_PAYOUTS = gql`
  query GetSupplierPayouts(
    $supplier_id: String
    $search: String
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
    $is_sme: Boolean
  ) {
    supplierPayouts(
      supplier_id: $supplier_id
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
      is_sme: $is_sme
    ) {
      data {
        supplier {
          id
          user {
            id
            name
            phone
            email
          }
        }
        total_payout
        payouts {
          id
          payment_method
          amount
          reference
          status
          created_at
          supplier {
            id
            user {
              name
            }
          }
        }
      }
      total_supplier_payouts

      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_SUPPLIERS_ORDERS_REPORT = gql`
  query GetSuppliersOrdersReport(
    $first: Int
    $page: Int
    $period: String
    $startDate: String
    $endDate: String
    $is_sme: Boolean
  ) {
    getSuppliersOrdersReport(
      first: $first
      page: $page
      period: $period
      startDate: $startDate
      endDate: $endDate
      is_sme: $is_sme
    ) {
      data {
        id
        user {
          name
          phone
        }
        total_withdrawal
        total_net_amount
        total_paid_amount
        remaining_amount
        payment_status
        businesses_report {
          business {
            id
            business_name
          }
          total_orders
          total_net_amount
          total_paid_amount
          remaining_amount
        }
        orders {
          id
          order_code
          net_amount
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const LIST_MICROFINANCES = gql`
  query ListMicrofinances(
    $search: String
    $status: String
    $startDate: Date
    $endDate: Date
    $loan_repayment_duration: Int
    $loan_repayment_duration_type: RepaymentDurationType
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput!]
  ) {
    microfinances(
      search: $search
      status: $status
      startDate: $startDate
      endDate: $endDate
      loan_repayment_duration: $loan_repayment_duration
      loan_repayment_duration_type: $loan_repayment_duration_type
      first: $first
      page: $page
      ordered_by: $ordered_by
    ) {
      data {
        id
        name
        phone_number
        max_loan_amount
        interest_rate
        loan_repayment_duration
        loan_repayment_duration_type
        status
        created_at
      }
      paginatorInfo {
        currentPage
        lastPage
        total
      }
    }
  }
`;
export const NON_PAGINATED_GET_MY_SUPPLIERS_Business = gql`
  query (
    $search: String
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
    $status: String
  ) {
    myBusinesses(
      search: $search
      first: $first
      status: $status
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        business_name
        categories {
          category {
            id
            name
            children {
              id
              name
            }
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_WARE_HOUSE_MANAGERS = gql`
  query (
    $search: String
    $warehouse_id: String
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    myWarehouseManagers(
      search: $search
      first: $first
      warehouse_id: $warehouse_id
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        warehouse {
          id
          name
        }
        user {
          id
          name
          phone
          email
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_WARE_HOUSE_SHIPPING = gql`
  query (
    $warehouse_id: String
    $search: String
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    myWarehouseShippingEstimations(
      warehouse_id: $warehouse_id
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        category {
          name
          id
        }
        warehouse {
          name
          id
        }
        period_type
        min_period
        max_period
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

// stock
export const GET_STOCKS = gql`
  query ($first: Int!, $page: Int) {
    stocks(first: $first, page: $page) {
      data {
        id
        quantity
        product_sku {
          sku
        }
        warehouse {
          name
        }
        transactions {
          before_quantity
          after_quantity
          transactionable {
            __typename
            ... on StockManagementAction {
              id
              type
            }
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

//orders
export const GET_ORDER = gql`
  query ($id: ID!) {
    order(id: $id) {
      id
      total_price
      items {
        id
        quantity
        state
        created_at
        product_sku {
          id
          sell_price
          sku
          is_active
          product {
            name
          }
        }
      }
      shipment_items {
        id
        shipment {
          id
          departure_time
          arrival_time
          status
          from {
            __typename
            ... on Warehouse {
              name
            }
          }
          to {
            __typename
            ... on Distributor {
              id
              name
            }
          }
        }
      }
      retailer {
        id
        name
        contact_phone
      }
      driver {
        id
        user {
          name
        }
      }
      transactions {
        id
        payment_method
        amount
        txn_ref
        type
      }
    }
  }
`;

export const GET_ORDERS = gql`
  query ($search: String, $first: Int!, $page: Int) {
    orders(search: $search, first: $first, page: $page) {
      data {
        id
        total_price
        created_at_human
        warehouse {
          name
        }
        created_at
        retailer {
          id
          name
        }
        state
        productSkuCount
        driver {
          id
          name
        }
        items {
          id
          quantity
          state
          product_sku {
            id
            sku
            sell_price
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const MY_GET_ORDERS = gql`
  query ($status: String, $search: String, $first: Int!, $page: Int) {
    myOrders(status: $status, search: $search, first: $first, page: $page) {
      data {
        id
        total_price
        created_at_human
        warehouse {
          name
        }
        order_code
        created_at
        retailer {
          id
          name
        }
        delivery_option
        status
        productSkuCount
        items {
          id
          quantity
          state
          product_sku {
            id
            sku
            sell_price
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_ORDERS_BY_STATUS = gql`
  query getOrdersByOrderItemStatus(
    $status: String!
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    getOrdersByOrderItemStatus(
      status: $status
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        total_price
        created_at_human
        created_at
        warehouse {
          name
        }
        retailer {
          id
          name
        }
        state
        driver {
          id
          name
        }
        productSkuCount
        items {
          id
          quantity
          state
          product_sku {
            id
            sku
            sell_price
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_ORDERS_BY_DROPOFF_STATUS = gql`
  query ($status: String!) {
    getOrdersByDropOffStatus(status: $status) {
      id
      total_price
    }
  }
`;

//  shipment
export const GET_SHIPMENT = gql`
  query ($id: ID!) {
    shipment(id: $id) {
      id
      arrival_time
      cost
      items {
        shipment_itemable {
          ... on OrderItem {
            order {
              id
              items {
                id
                product_sku {
                  id
                  sku
                  product {
                    name
                  }
                }
              }
            }
          }
        }
      }
      departure_time
      from {
        __typename
        ... on Warehouse {
          id
          name
        }
        ... on Distributor {
          id
          name
        }
      }
      to {
        __typename
        ... on Retailer {
          id
          name
        }
        ... on Distributor {
          id
          name
        }
        ... on Warehouse {
          id
          name
        }
      }
    }
  }
`;

export const GET_SHIPMENTS = gql`
  query ($search: String, $status: String, $first: Int!, $page: Int) {
    shipments(search: $search, status: $status, first: $first, page: $page) {
      data {
        id
        departure_time
        self_shipment
        arrival_time
        items {
          shipment_itemable {
            ... on OrderItem {
              order {
                id
                items {
                  id
                  product_sku {
                    id
                    sku
                    product {
                      name
                      images {
                        id
                        original_url
                      }
                    }
                  }
                }
              }
            }
          }
        }
        cost
        status
        from {
          __typename
          ... on Warehouse {
            id
            warehouse_name: name
          }
          ... on Distributor {
            id
            distributor_name: name
          }
        }
        to {
          __typename
          ... on Retailer {
            id
            retailer_name: name
          }
          ... on Distributor {
            id
            distributor_name: name
          }
          ... on Warehouse {
            id
            warehouse_name: name
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

// Dashboard queries
export const GET_ALL_GEO_LOCATIONS = gql`
  query {
    distributorsNonPaginated {
      id
      name

      region {
        name
      }
      _geo {
        lat
        lng
      }
    }

    warehousesNonPaginated {
      id
      name
      region {
        id
        name
      }
      _geo {
        lat
        lng
      }
    }
  }
`;

// wallet queries
export const DEPOSIT_SLIPS = gql`
  query ($first: Int!, $page: Int) {
    depositSlips(first: $first, page: $page) {
      data {
        id
        reference_number
        confirmed_at_human
        amount
        retailer {
          id
          name
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const DEPOSIT_SLIP = gql`
  query ($id: ID!) {
    depositSlip(id: $id) {
      amount
      slip
      confirmed_at_human
      reference_number
      retailer {
        name
      }
    }
  }
`;

//vehicle types
export const GET_VEHICLE_TYPES = gql`
  query ($first: Int!, $page: Int, $search: String) {
    vehicleTypes(first: $first, search: $search, page: $page) {
      data {
        id
        title
        status
        image
        type
        starting_price
        price_per_kilometer
        vehicleCount
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_VEHICLE_TYPE = gql`
  query ($id: ID!) {
    vehicleType(id: $id) {
      id
      title
      type
      image
      starting_price
      price_per_kilometer
    }
  }
`;
export const GET_UNASSIGNED_DRIVERS = gql`
  query {
    getUnAssignedDrivers {
      id
      user {
        id
        name
      }
    }
  }
`;
export const GET_UNASSIGNED_WAREHOUSES = gql`
  query UnassignedWarehouses($search: String, $ordered_by: [OrderByInput]!) {
    unassignedWarehouses(search: $search, orderBy: $ordered_by) {
      id
      name
      status
      region {
        id
        name
      }
    }
  }
`;
export const GET_DRIVERS = gql`
  query ($first: Int!, $page: Int) {
    drivers(first: $first, page: $page) {
      data {
        id
        user {
          id
          name
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_DRIVER = gql`
  query ($id: ID!) {
    driver(id: $id) {
      id
      name
      city
      phone
      email
      address
    }
  }
`;

//vehicles
export const GET_VEHICLES = gql`
  query (
    $first: Int!
    $page: Int
    $search: String
    $ordered_by: [OrderByInput]!
  ) {
    vehicles(
      first: $first
      page: $page
      search: $search
      orderBy: $ordered_by
    ) {
      data {
        id
        owner_name
        color
        plate_number
        owner_phone
        libre_number
        plate_doc
        license_doc
        libre_doc
        license_number
        license_number
        vehicle_type {
          id
          title
        }
        region {
          name
        }
        driver {
          id
          user {
            name
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const Warehouse_dashboard = gql`
  query ($period_type: String!, $limit: Int) {
    warehouseManagerDashboard(period_type: $period_type, limit: $limit) {
      total_sales
      total_orders
      total_active_orders
      top_products {
        id
        name
        total_sales
        total_orders
      }
    }
  }
`;
export const SUPPLIER_DASHBOARD = gql`
  query ($period_type: String!, $limit: Int) {
    supplierDashboard(period_type: $period_type, limit: $limit) {
      total_sales
      total_orders
      total_active_orders
      top_products {
        id
        name
        total_sales
        total_orders
      }
      top_supplier_businesses {
        id
        business_name
        total_sales
        total_orders
      }
      top_warehouses {
        id
        name
        total_sales
        total_orders
      }
      orders_bar_chart {
        business_id
        business_name
        total_orders
        total_sales
      }
    }
  }
`;
export const ADMIN_DASHBOARD = gql`
  #period type: DAILY, WEEKLY, MONTHLY, QUARTERLY, HALF_YEAR, YEARLY
  query ($period_type: String!, $limit: Int) {
    getAdminDashboard(period_type: $period_type, limit: $limit) {
      total_commission_from_suppliers
      total_sme_commission
      total_commission_from_drivers
      top_suppliers {
        id
        name
        total_sales
      }
      top_sme {
        id
        name
        total_sales
      }

      top_retailers {
        id
        name
        total_orders
      }
      top_drivers {
        id
        name
        total_dropoffs
      }
    }
  }
`;
export const USERS = gql`
  query {
    getUserStatusDashboard {
      total_drivers
      total_retailers
      total_suppliers
      total_sme_suppliers
    }
  }
`;
export const GET_VEHICLE = gql`
  query ($id: ID!) {
    vehicle(id: $id) {
      id
      model
      owner_name
      color
      plate_number
      owner_phone
      plate_doc
      license_doc
      libre_doc
      libre_number
      license_number
      vehicle_type {
        id
        title
      }
      region {
        id
        name
      }
      driver {
        id
        user {
          name
        }
      }
    }
  }
`;

//dropoffs

export const GET_DROPOFFS = gql`
  query ($status: String, $search: String, $first: Int!, $page: Int) {
    dropoffs(status: $status, search: $search, first: $first, page: $page) {
      data {
        id
        status
        cost
        dropoff_order {
          order {
            retailer {
              name
            }
          }
        }
        driver {
          id
          name
        }
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const PRODUCT_DISCOUNT = gql`
  query (
    $supplier_business_id: String
    $product_id: String
    $search: String
    $first: Int
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    myProductDiscounts(
      supplier_business_id: $supplier_business_id
      product_id: $product_id
      search: $search
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        discount_value_type
        discount_value
        start_date
        end_date
        product {
          id
          name
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const getDropoffsQuery = (role) => gql`
  query ($status: String, $search: String, $first: Int!, $page: Int, $ordered_by: [OrderByInput]!) {
    ${
      role === "admin"
        ? "dropoffs"
        : role === "supplier"
          ? "supplierDropoffs"
          : "warehouseManagerDropoffs"
    }(status: $status, search: $search, first: $first, page: $page, orderBy: $ordered_by) {
      data {
        id
        status
        cost
        dropoff_order {
          order {
           warehouse {
          name
        }
          order_code
            retailer {
              name
            }
          }
        }
        driver {
          user{
          name
  }
        }
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_DROPOFF = gql`
  query ($id: ID!) {
    dropoff(id: $id) {
      id
      status
      from {
        ... on Distributor {
          id
          name
        }
      }
      driver {
        user {
          name
          phone
        }
        city
      }
      dropoff_order {
        id
        received
        order {
          id
          total_price
          retailer {
            name
            contact_phone
            address
            city
          }
          transactions {
            id
            payment_method
            amount
            txn_ref
            type
          }
          items {
            id
            quantity

            product_sku {
              id
              sku
              sell_price
              product {
                name
                images {
                  original_url
                }
              }
            }
          }
        }
      }
    }
  }
`;

//general users query

export const GET_ALL_USERS = gql`
  query ($first: Int!, $search: String, $role: String, $page: Int) {
    users(first: $first, search: $search, role: $role, page: $page) {
      data {
        id
        name
        status
        email
        phone
        profile_image
        roles {
          id
          name
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const GET_ALL_SUPPLIERS = gql`
  query (
    $search: String
    $status: String
    $first: Int
    $sales_id: String
    $period: String
    $startDate: String
    $is_sme: Boolean
    $endDate: String
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    getSuppliers(
      search: $search
      status: $status
      is_sme: $is_sme
      period: $period
      startDate: $startDate
      endDate: $endDate
      first: $first
      sales_id: $sales_id
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        user {
          id
          name
          phone
          email
          profile_image
          status
        }
        businesses {
          id
          business_name
          status
          number_of_warehouses
          total_balance
        }
        registeredBy {
          id
          name
        }
        total_balance
        total_withdrawal
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
export const GET_SME_SUPPLIERS = gql`
  query ($is_sme: Boolean, $search: String, $first: Int, $page: Int) {
    getSuppliers(is_sme: $is_sme, search: $search, first: $first, page: $page) {
      data {
        id
        user {
          id
          name
          phone
          email
          status
        }
        businesses {
          id
          business_name
        }
        total_balance
        total_withdrawal
      }
      paginatorInfo {
        total
        currentPage
        lastPage
        perPage
      }
    }
  }
`;

export const GET_SME_SUPPLIERS_BUSINESSES = gql`
  query GetSmeSuppliersBusinesses(
    $search: String
    $supplier_id: String
    $status: String
    $first: Int!
    $page: Int
    $ordered_by: [OrderByInput]!
  ) {
    smeSuppliersBusinesses(
      search: $search
      supplier_id: $supplier_id
      status: $status
      first: $first
      page: $page
      orderBy: $ordered_by
    ) {
      data {
        id
        supplier_code
        business_name
        business_email
        business_website
        business_phone_number
        business_type
        business_kebele
        business_zone
        business_woreda
        business_region {
          id
          name
        }
        owner_firstname
        owner_middlename
        owner_lastname
        owner_phone_number
        owner_id_type
        owner_id_url
        number_of_warehouses
        tin
        business_registration_number
        total_balance
        total_withdraw
        trade_license_document_url
        tin_certification_document_url
        status
        categories {
          category {
            name
          }
        }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

// roles query

export const GET_ROLES = gql`
  query {
    roles {
      id
      name
    }
  }
`;

// Loan Applications Queries
export const LOAN_APPLICATIONS = gql`
  query LoanApplications(
    $status: String
    $workflow_status: String
    $user_id: ID
    $borrower_type: String
    $search: String
    $collateral_type: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    loanApplications(
      status: $status
      workflow_status: $workflow_status
      user_id: $user_id
      borrower_type: $borrower_type
      search: $search
      collateral_type: $collateral_type
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        trx
        user_id
        product_name
        requested_amount
        approved_amount
        term
        purpose
        status
        workflow_status
        collateral_type
        borrower_type
        purchase_items
        review_remark
        reviewed_at
        maker_remark
        maker_submitted_at
        checker_remark
        checker_action
        checker_acted_at
        approver_remark
        approver_action
        approver_acted_at
        approved_at
        approved_by
        credit_score
        risk_tier
        recommended_loan_limit
        credit_score_confidence
        credit_score_reasons
        created_at
        updated_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const LOAN_APPLICATION = gql`
  query LoanApplication($id: ID!) {
    loanApplication(id: $id) {
      id
      trx
      user_id
      borrower_type
      purchase_items
      requested_amount
      approved_amount
      term
      purpose
      status
      workflow_status
      collateral_type
      review_remark
      reviewed_at
      maker_remark
      maker_submitted_at
      checker_remark
      checker_action
      checker_acted_at
      approver_remark
      approver_action
      approver_acted_at
      approved_amount
      approved_at
      approved_by
      credit_score
      risk_tier
      recommended_loan_limit
      credit_score_confidence
      credit_score_reasons
      created_at
      updated_at
      workflow_history {
        id
        action
        actor_id
        actor_name
        remark
        created_at
      }
    }
  }
`;

// Loan Customer Query
export const LOAN_CUSTOMER = gql`
  query LoanCustomer($user_id: ID!) {
    loanCustomer(user_id: $user_id) {
      user_id
      name
      borrower_type
      related_documents {
        name
        url
      }
      loan_history {
        id
        trx
        requested_amount
        approved_amount
        term
        purpose
        status
        workflow_status
        collateral_type
        borrower_type
        created_at
      }
    }
  }
`;

// Loan Accounts Queries
export const LOAN_ACCOUNTS = gql`
  query LoanAccounts(
    $status: String
    $user_id: ID
    $search: String
    $product_id: ID
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    loanAccounts(
      status: $status
      user_id: $user_id
      search: $search
      product_id: $product_id
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        trx
        application_id
        user_id
        product_id
        product_name
        principal
        interest_type
        interest_rate
        repayment_frequency
        term
        service_charge
        insurance_fee
        disaster_fee
        stamp_duty
        processing_fee
        collateral_type
        total_payable
        total_paid
        outstanding
        status
        disbursed_at
        due_date
        closed_at
        created_at
        updated_at
        # product {
        #   id
        #  name
        # }
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

export const LOAN_ACCOUNT = gql`
  query LoanAccount($id: ID!) {
    loanAccount(id: $id) {
      id
      trx
      application_id
      user_id
      product_id
      principal
      interest_type
      interest_rate
      repayment_frequency
      term
      service_charge
      insurance_fee
      disaster_fee
      stamp_duty
      processing_fee
      collateral_type
      total_payable
      total_paid
      outstanding
      status
      disbursed_at
      due_date
      closed_at
      created_at
      updated_at
    }
  }
`;

// Loan Summary Query
export const LOAN_SUMMARY = gql`
  query LoanSummary($loan_account_id: ID!) {
    loanSummary(loan_account_id: $loan_account_id) {
      id
      trx
      principal
      interest_type
      interest_rate
      term
      processing_fee
      total_payable
      total_paid
      outstanding
      status
      progress_percent
      total_installments
      paid_installments
      overdue_installments
      overdue_amount
      disbursed_at
      due_date
      closed_at
      next_installment {
        id
        installment_no
        due_date
        principal_due
        interest_due
        total_due
        penalty_due
        amount_paid
        status
        paid_at
      }
      schedule {
        id
        installment_no
        due_date
        principal_due
        interest_due
        total_due
        penalty_due
        amount_paid
        status
        paid_at
      }
    }
  }
`;

// Loan Installments Query
export const LOAN_INSTALLMENTS = gql`
  query LoanInstallments(
    $loan_account_id: ID!
    $status: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    loanInstallments(
      loan_account_id: $loan_account_id
      status: $status
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        loan_account_id
        installment_no
        due_date
        principal_due
        interest_due
        total_due
        penalty_due
        amount_paid
        status
        paid_at
        last_penalty_accrued_at
        reminder_sent_at
        created_at
        updated_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

// Loan Workflow History Query
export const LOAN_WORKFLOW_HISTORY = gql`
  query LoanWorkflowHistory(
    $application_id: ID!
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    loanWorkflowHistory(
      application_id: $application_id
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        application_id
        action
        actor_id
        actor_name
        remark
        created_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;

// Loan Provider Staff Query
export const LOAN_PROVIDER_STAFF = gql`
  query GetLoanProviderStaff(
    $role: String
    $is_active: Boolean
    $search: String
    $first: Int
    $page: Int
    $orderBy: [OrderByInput]
  ) {
    loanProviderStaff(
      role: $role
      is_active: $is_active
      search: $search
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        provider_id
        user_id
        role
        is_active
        user {
          id
          name
          email
          phone
        }
        created_at
        updated_at
      }
      paginatorInfo {
        count
        currentPage
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
`;
